import type { Configuration } from './generated'

export const addCredentials = (configuration: Configuration): void => {
  configuration.baseOptions = {
    ...configuration.baseOptions,
    withCredentials: true,
  }
}
